export const BLOCK = 64;
export const FUSE_OPT = {
  shouldSort: true,
  includeScore: true,
  threshold: 0.6,
  location: 0,
  distance: 100,
  maxPatternLength: 32,
  minMatchCharLength: 1
};



// WEBPACK FOOTER //
// ./src/utils/constants.ts